const globalTheme = {
  typography: {
    h1: {
      fontSize: "1.25rem",
      color: "#4C466F",
      fontFamily: "Vazir",
    },
    h2: {
      fontFamily: "Vazir!important",
      fontSize: "0.88rem",
      color: "#4C466F",
      letterSpacing: "0 !important",
      direction: "rtl",
    },
    h3: {
      fontSize: "14px",
      color: "#4C466F",
    },
    h4: {
      // fontFamily:"Vazir",
      fontSize: "16.68px",
      color: "#4C466F",
    },
    h5: {
      fontFamily: "Vazir",
      fontSize: "28px",
      color: "#1E265E",
      fontWeight: "600",
    },
    h6: {
      fontFamily: "Vazir!important",
      fontSize: "14px",
      color: "#4C466F",
    },
    h7: {
      fontFamily: "Vazir!important",
      fontSize: "14px",
      color: "#9995B1",
    },
    subtitle1: {
      fontFamily: "Vazir!important",
      fontSize: "0.9rem",
      color: "#4C466F",
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "xl" },
          style: {},
        },
        {
          props: { variant: "l" },
          style: {
            width: "248px",
            height: "48px",
            background: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
            borderRadius: "12px",
            color: "#FFFFFF",
            fontFamily: "VazirThin",
            fontSize: "14px",
            padding: "6px 21px",
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: "#FB83AC",
              color: "#fff",
            },
          },
        },
        {
          props: { variant: "m1" },
          style: {
            width: "auto",
            height: "48px",
            background: "linear-gradient(270deg, #ED304D 5.82%, #03009F 132.42%)",
            borderRadius: "12px",
            color: "#FFFFFF",
            fontFamily: "VazirThin",
            padding: "6px 21px",
            fontSize: "14px",
          },
        },
        {
          props: { variant: "m2" },
          style: {
            width: "165px",
            height: "48px",
            backgroundColor: "#E8E8E8",
            borderRadius: "12px",
            color: "#4C466F",
            fontFamily: "VazirThin",
            padding: "6px 21px",
            fontSize: "14px",
          },
        },
        {
          props: { variant: "m3" },
          style: {
            width: "165px",
            height: "48px",
            backgroundColor: "#8BA4FF",
            borderRadius: "12px",
            color: "#fff",
            fontFamily: "VazirThin",
            padding: "6px 21px",
            fontSize: "14px",
          },
        },
        {
          props: { variant: "m4" },
          style: {
            width: "auto",
            height: "48px",
            backgroundColor: "#4318FF",
            borderRadius: "70px",
            color: "#fff",
            fontFamily: "VazirThin",
            padding: "6px 21px",
            fontSize: "14px",
          },
        },
        {
          props: { variant: "s1" }, //search and send to center
          style: {
            width: "auto",
            height: "32px",
            background: "linear-gradient(270deg, #ED304D 5.82%, #03009F 132.42%)",
            borderRadius: "22.27px",
            color: "#FFFFFF",
            fontFamily: "VazirThin",
            padding: { xs: "6px 10px", sm: "6px 21px", md: "6px 21px" },
            fontSize: "14px",
          },
        },
        {
          props: { variant: "s2" }, //save form
          style: {
            width: "auto",
            height: "32px",
            backgroundColor: "#FAFAFA",
            borderRadius: "22.27px",
            color: "#4C466F",
            fontFamily: "VazirThin",
            padding: { xs: "3px 10px", sm: "6px 21px", md: "6px 21px" },
            fontSize: "14px",
          },
        },
        {
          props: { variant: "accept" },
          style: {
            minWidth: "110px",
            height: "32px",
            background: "linear-gradient(270deg, #ED304D 5.82%, #03009F 132.42%)",
            borderRadius: "0.7rem",
            color: "#FFFFFF",
            fontFamily: "VazirThin",
            padding: { xs: "3px 10px", sm: "6px 21px", md: "6px 21px" },
          },
        },
        {
          props: { variant: "cancel" },
          style: {
            minWidth: "110px",
            height: "32px",
            marginRight: "1rem",
            borderRadius: "0.7rem",
            backgroundColor: "#E8E8E8",
            color: "#2F3B60",
            fontFamily: "VazirThin",
            padding: { xs: "3px 10px", sm: "6px 21px", md: "6px 21px" },
          },
        },
        {
          props: { variant: "navLink" },
          style: {
            width: "100%",
            height: "48px",
            backgroundColor: "transparent",
            borderRadius: "16px",
            color: "#4C466F",
            justifyContent: "right",
            alignItems: "center",
            fontSize: "14px",
            "&:hover, &.Mui-focusVisible, &:active": {
              backgroundColor: "rgba(255,255,255,0.3)",
              color: "#fff",
            },
            "@media (max-width:425px)": {
              display: "none",
            },
          },
        },
        {
          props: { variant: "switch" },
          style: {
            width: "auto",
            height: "48px",
            backgroundColor: "transparent",
            borderRadius: "12px",
            color: "#9895A9",
            justifyContent: "right",
            alignItems: "center",
            fontSize: "14px",
            "&:hover, &.Mui-focusVisible, &:active": {
              background: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
              color: "#fff",
            },
            "@media (max-width:425px)": {
              display: "none",
            },
          },
        },
        {
          props: { variant: "delete" },
          style: {
            width: "40px",
            height: "40px",
            backgroundColor: "#EAEAEA",
            borderRadius: "10px",
            padding: "10px 12px",
          },
        },
      ],
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: "#4C466F",
          backgroundColor: "#FAFAFA",
          direction: "rtl",
          fontSize: "13px",
          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.10))",
          "& .MuiTooltip-arrow": {
            color: "#FAFAFA",
          },
          boxSizing: "border-box",
          padding: "0.5rem 0.7rem",
        },
      },
    },
  },
};
export default globalTheme;
